import { Typography } from '@mui/material';
import React, { ReactElement } from 'react';

interface IFormikValidationError {
  name: string;
  touched: { [key: string]: any | undefined };
  errors: { [key: string]: any | undefined };
}

interface IFormikFieldArrayValidationError extends IFormikValidationError {
  index: number;
  keyName: string;
}

export function FormikFieldArrayValidationError(
  props: IFormikFieldArrayValidationError
): ReactElement {
  const { name, touched, errors, index, keyName } = props;

  if (`${keyName}` in errors && `${keyName}` in touched && errors[keyName][index]) {
    return (
      <Typography fontSize={12} sx={{ color: (theme) => theme.palette.error.light }}>
        {' '}
        {errors[keyName][index][name] && <span></span>} {errors[keyName][index][name] as string}
      </Typography>
    );
  }

  return <span></span>;
}

function FormikValidationError(props: IFormikValidationError): ReactElement {
  const { name, touched, errors } = props;
  const fieldNames = name.split('.');

  const message = fieldNames.reduce((result, currentValue) => {
    return result?.[currentValue];
  }, errors);

  const fieldTouched =
    fieldNames.length > 1 ? touched[fieldNames[0]]?.[fieldNames[1]] : touched[name];

  return fieldTouched && !!message ? (
    <div className="text-danger">{message as React.ReactNode}</div>
  ) : (
    <></>
  );
}
export default FormikValidationError;
